import type { MonthlyPaymentRender } from "../../../lib/agent-types";
import { MonthlyPaymentPreview } from "../../dashboard/calculators/monthly-payment-preview";
import { WidgetFrame } from "../widget-frame";

export function MonthlyPaymentWidget({
  payload,
}: {
  payload: MonthlyPaymentRender;
}) {
  return (
    <WidgetFrame data-widget-type="monthly_payment">
      <MonthlyPaymentPreview
        estimate={{ results: payload.estimate.results }}
        request={payload.estimate.request}
      />
    </WidgetFrame>
  );
}
